<template>
  <div>
    <page-title
      heading="Manajemen Poliklinik"
      :breadcrumb="[
        {
          label: 'Manajemen Poliklinik',
          link: '/poliklinik',
          active: true
        }
      ]"
    />
    <div class="container-fluid __table-manajemen">
      <div class="card card-box mb-3 ninja-shadow mt-3">
        <div class="card-body">
          <div class="col-md-12 no-padding">
            <DataTableWrapper
              :rows="rows"
              :perPage="perPage"
              :currentPage="currentPage"
              :callbackFunc="fetchList"
              @valueChanged="handleValueChanged"
            >
             <template v-slot:right-header>
                <b-button
                    variant="primary"
                    class="text-capitalize align-self-end"
                    :to="{
                        name: 'poliklinik-tambah'
                    }">
                    tambah poliklinik
                </b-button>
              </template>
              <b-table
                :items="PoliklinikList"
                :fields="fieldList"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                thead-tr-class="izd-datatable"
                :no-local-sorting="true"
              >
                <!-- HEAD  -->

                <template v-slot:head()="data">
                  {{ data.label }}
                  <b-input
                    size="sm"
                    class="mt-2 w-95"
                    v-if="data.field.searchable"
                    @input="searchValueChanged($event, data.field.key)"
                  />
                </template>

                <!-- DATA  -->

                <template v-slot:cell(expand)="data">
                  <a href="#" v-if="data.item.dokter.length > 1 || data.item.jadwal.length > 1" @click.prevent="toggleExpand(data)">
                    <template v-if="data.item.is_expand">
                      <font-awesome-icon
                        icon="chevron-down"
                        style="color:3c44b1;"
                      />
                    </template>
                    <template v-else>
                      <font-awesome-icon
                        icon="chevron-right"
                        style="color:3c44b1;"
                      />
                    </template>
                  </a>
                </template>

                <template v-slot:cell(nama)="data">
                  <div class="media">
                    <div class="media-body">{{ data.value }}</div>
                    <span
                      v-if="checkSyncSatuSehat(data.item) == 'success'"
                      :id="'success-' + data.item.id"
                      v-tooltip="{
                        content: `Berhasil Sinkronisasi Dengan SatuSehat`,
                        classes: 'satusehat-tooltip',
                      }"
                    >
                      <img src="/img/satusehat_berhasil.png" class="icon_sync_satusehat"/>
                    </span>
                    <span
                      v-if="checkSyncSatuSehat(data.item) == 'failed'"
                      :id="'failed-' + data.item.id"
                      v-tooltip="{
                        content: `Gagal Sinkronisasi Dengan SatuSehat`,
                        classes: 'satusehat-tooltip',
                      }"
                    >
                      <img src="/img/satusehat_gagal.png" class="icon_sync_satusehat"/>
                    </span>
                  </div>
                </template>

                <template v-slot:cell(kategori_pasien)="data">
                  <template v-for="(kategori, i) in data.item.kategori_pasien">
                    {{ i > 0 ? ',' : '' }} {{ kategori.nama }}
                  </template>
                </template>

                <template v-slot:cell(dokter)="data">
                  <div v-if="data.item.is_expand == false && data.item.dokter.length > 0">
                    {{ data.item.dokter[0].nama }}
                  </div>
                  <template v-if="data.item.is_expand == true">
                    <div v-for="(dokter) in data.item.dokter" :key="dokter.nama">
                      {{ dokter.nama }}
                    </div>
                  </template>
                </template>

                <template v-slot:cell(jadwal)="data">
                  <div v-if="data.item.is_expand == false && data.item.jadwal.length > 0">
                    {{ `${data.item.jadwal[0].hari} ${displayTime(data.item.jadwal[0].jam_mulai)} - ${displayTime(data.item.jadwal[0].jam_selesai)}` }}
                  </div>
                  <template v-if="data.item.is_expand == true">
                    <div v-for="(jadwal) in data.item.jadwal" :key="jadwal.nama">
                    {{ `${jadwal.hari} ${displayTime(jadwal.jam_mulai)} - ${displayTime(jadwal.jam_selesai)}` }}
                    </div>
                  </template>
                </template>

                <template v-slot:cell(status)="data">
                  <b-badge variant="success" v-if="data.item.status.toLowerCase() == 'buka'" style="font-size:80%;display:block">{{ data.item.status }}</b-badge>
                  <b-badge variant="danger" v-else style="font-size:80%;display:block">{{ data.item.status }}</b-badge>
                </template>

                <template v-slot:cell(actions)="data">
                  <span>
                    <b-dropdown
                      id="dropdown-1"
                      class="m-md-2 text-capitalize"
                      variant="primary"
                      size="sm"
                      right
                    >
                      <template v-slot:button-content>
                        <font-awesome-icon icon="copy" />
                      </template>
                      <b-dropdown-item
                        @click="
                          edit(data)
                        "
                      >
                        Edit Data 
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click="
                          hapus(data)
                        "
                      >
                        Hapus Data 
                      </b-dropdown-item>
                      <b-dropdown-item
                          v-if="checkSyncSatuSehat(data.item) == 'failed'"
                          @click="syncSatuSehat(data.item)"
                        >
                          Sinkronisasi Ulang
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </template>
                <template v-slot:cell(updated)="data">
                    <label style="font-size:12px;">
                        <div v-if="data.item.updated && data.item.updated.at">{{ data.item.updated.at }}</div>
                        <div v-if="data.item.updated && data.item.updated.by">by <strong>{{ data.item.updated.by }}</strong></div>
                    </label>
                </template>
              </b-table>
            </DataTableWrapper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import debounce from "lodash/debounce";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronDown,
  faChevronRight,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
moment.locale("id");
import "vue-datetime/dist/vue-datetime.css";
import { mapGetters } from "vuex";
library.add(faChevronDown, faChevronRight, faCopy);

export default {
  components: {
    DataTableWrapper: () =>
      import("../../components/DataTableWrapperSubkripsi"),
  },
  data() {
    return {
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      rows: 0,
      fromPage: 0,
      toPage: 0,
      optionRole: [],
      optionSpesialisasi: [],
      perPage: 10,
      PoliklinikList: [],
      searchValue: [],
      clickModal: false,
      totalEntries: 0,
      selected: [],
      selectedSpesialisasi: [],
      selectedKlinik: [],
      checked: null,
      selectedDate: null,
      isRoleDokter: null,
      isRolePIC: null,
      errFormData: {
        nama: {
          error: null,
          desc: null
        },
        email: {
          error: null,
          desc: null
        },
        nomor_telp: {
          error: null,
          desc: null
        },
        role: {
          error: null,
          desc: null
        },
        status: {
          error: null,
          desc: null
        },
        sip: {
          error: null,
          desc: null
        },
        masa_berlaku: {
          error: null,
          desc: null
        },
        spesialisasi: {
          error: null,
          desc: null
        },
        nama_klinik: {
          error: null,
          desc: null
        },
        kab: {
          error: null,
          desc: null
        }
      },
      formData: {
        nama: null,
        email: null,
        nomor_telp: null,
        role: null,
        status: null,
        sip: null,
        masa_berlaku: null,
        spesialisasi: null,
        nama_klinik: null,
        kab: null
      }
    };
  },
  watch: {
    currentPage() {
      this.fetchList();
    },
    perPage() {
      this.fetchList();
    },
    sortBy() {
      this.fetchList();
    },
    sortDesc() {
      this.fetchList();
    },
    searchValue: {
      handler: "fetchList",
      deep: true
    }
  },
  computed: {
    ...mapGetters(["getKlinikId", "satusehatAuthValid"]),
    fieldList() {
      const {
        generateFieldList: g,
        setSearchableAndSortableFieldList: s
      } = this;
      const r = val =>
        Boolean(
          /(actions|checklist|updated|expand|jadwal)\b/gi.test(val) ? !1 : 1
        );
      return (
        [
          { key: "expand", label: "" },
          { key: "nama", label: "Nama Poliklinik/Unit" },
          { key: "kategori_pasien", label: "Kategori Pasien" },
          { key: "dokter", label: "Nama Dokter" },
          { key: "status", label: "Status" },
          { key: "jadwal", label: "Jadwal Poliklinik" },
          { key: "actions" },
          { key: "updated", label: "Last Modified" }
        ]
        |> (v => s({ field: v, customFunc: r }))
        |> (z => g({ field: z }))
      );
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    async syncSatuSehat(item) {
      try {
        const res = await this.$axios.post(`satu-sehat/poliklinik/sync/${item.id}`, {
          nama: item.nama,
          klinik_id: this.getKlinikId,
          status: item.status == 'Buka' ? 1 : 0,
          location_id: item.location_id
        });
        const { status, message } = res.data;
  
        if (status) {
          this.$swal({
            html: message,
            type: 'success',
            confirmButtonText: 'OK'
          }).then(async res => {
            if (res.value) {
              await this.fetchList();
            }
          });
          return;
        }
        this.$swal({
          html: `<p>izidok gagal melakukan sync ke SatuSehat</p><br><small class="text-danger">Catatan: ${message}</small>`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Tutup',
          confirmButtonText: 'Coba Lagi',
          cancelButtonColor: '#1bc943',
          allowOutsideClick: false,
        }).then(async res => {
          if (res.value && item) {
            await this.syncSatuSehat(item);
          }
        });
      } catch (error) {
        let msg = '';
        if (error.response && error.response.status == 422) {
          let dt = error.response.data;
          if (Object.keys(dt).length > 1) {
            msg += '<ol class="text-left ml-5">';
            Object.keys(dt).forEach(d => {
              msg += `<li>${dt[d]}</li>`;
            });
            msg += '</ol>';
          } else {
            let arr = [];
            Object.keys(dt).forEach(d => {
              arr.push(dt[d]);
            });
            msg += arr.join(', ')
          }
        } else {
          msg = error.statusText
        }
        this.$swal({
          html: `<p>izidok gagal melakukan sync ke SatuSehat</p><br><small class="text-danger">Catatan: ${msg}</small>`,
          type: 'error',
          showCancelButton: true,
          cancelButtonText: 'Tutup',
          confirmButtonText: 'Coba Lagi',
          cancelButtonColor: '#1bc943',
          allowOutsideClick: false,
        }).then(async res => {
          if (res.value && item) {
            await this.syncSatuSehat(item);
          }
        });
      }
    },
    checkSyncSatuSehat(data) {
      let result = null;
      if (this.satusehatAuthValid) {
        if (data.synced_to_satusehat == 1 && data.healthcare_service_id != null && data.healthcare_service_id != '') result = 'success';
        else if (
          (data.synced_to_satusehat == null || data.synced_to_satusehat == 2 || data.synced_to_satusehat == 0)
          && (data.healthcare_service_id == null || data.healthcare_service_id == '')
        ) result = 'failed';
      }
      return result;
    },
    displayTime(d) {
      let r = moment(d).format('HH:mm')
      if(r == 'Invalid date') {
        r = moment(d, 'HH:mm:ss').format('HH:mm')
      }
      return r
    },
    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPage = _)));
      currentPage && (currentPage |> (_ => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function(val, key) {
      const { searchValue } = this;
      const z = searchValue.filter(item => item.key !== key);
      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];
    }, 500),
    toggleExpand(data) {
      data.item.is_expand = !data.item.is_expand;
    },
    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";

      searchValue.map(item => {
        const x = item.key;
        v += `&${x}=${item.value}`;
      });

      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }

      return v;
    },
    async fetchList() {
      try {
        const res = await this.$axios.get(
          `poliklinik?klinik_id=${this.getKlinikId}&limit=${
            this.perPage
          }&page=${this.currentPage}${this.determineParameter()}`
        );
        const { status, data } = res.data;

        if (status) {
          const {
            data: listData,
            total: totalEntries,
            to: toPage,
            from: fromPage
          } = data;

          this.totalEntries = totalEntries;
          this.toPage = toPage;
          this.fromPage = fromPage;
          this.rows = totalEntries;

          this.PoliklinikList = [
            ...listData.map((item, index) => {
              return {
                ...item,
                no: (this.currentPage - 1) * this.perPage + index + 1,
                is_expand: false,

                updated: {
                  at: item.updated.at ? moment(item.updated.at).format("MMM DD, YYYY @ HH:mm") : item.updated.at,
                  by: item.updated.at ? (item.updated.by || "anonim") : item.updated.by
                }
              };
            })
          ];
          return this;
        }
      } catch (err) {
      }
    },
    edit(data) {
      this.$router.push({
        name: 'poliklinik-edit',
        params: {
          id_poli: data.item.id
        }
      })
    },
    hapus(data) {
      this.$swal({
        text: `Anda yakin ingin menghapus data ini?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1791EE",
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya"
      }).then(async res => {
        if (res.value) {
          await this.deleteData(data.item.id);
        }
      });
    },
    async deleteData(id) {
      try {
        const res = await this.$axios.delete(`poliklinik/${id}?klinik_id=${this.getKlinikId}`);
        const { status, data } = res.data;
        if (status) {
          this.$swal({
            type: "success",
            text: "Data berhasil dihapus"
          }).then(() => {
            this.fetchList()
          })
        } else {
          this.failedSwal("Data gagal dihapus")
        }
      } catch (err) {
          this.failedSwal("Data gagal dihapus")
      }
    },
  }
};
</script>

<style lang="css">
.satusehat-tooltip .tooltip-inner {
  background: #ffffff !important;
  color: #858585 !important;
}

.satusehat-tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #ffffff;
  z-index: 1;
}

.icon_sync_satusehat {
  width: 35px;
  padding: 5px;
  font-size:2.3em;
  margin-top: -5px;
  cursor: pointer;
}
</style>